import styled from "styled-components";

import { shimmer } from "shared/components/molecules/LoadingSkeleton/atoms/styles";

interface IImageFallbackProps {
  backgroundColor: string;
}

export const ImageFallback = styled.div<IImageFallbackProps>`
  background-color: ${({ backgroundColor }) => backgroundColor || "#050505"};
  grid-area: image;
  border-radius: inherit;
`;

export const TopicLessonContainer = styled.div`
  button {
    display: flex;
    align-items: center;
    gap: 12px;

    width: 100%;

    padding: 0.7188rem 1rem;

    background-color: transparent;
    border: none;

    transition: 0.3s all;

    border-radius: 4px;

    :hover {
      cursor: pointer;
    }

    :hover,
    &.active {
      background-color: ${({ theme }) =>
        theme.mode === "dark" ? "#29272c" : "#d2d2d7"} !important;
    }

    .image-container,
    .image-skeleton {
      max-width: 92.12px;
    }

    .texts {
      margin: 0;
      width: 100%;
    }
  }

  img,
  ${ImageFallback} {
    border-radius: 4px;
  }

  .image-container,
  ${ImageFallback}, .image-skeleton {
    position: relative;

    aspect-ratio: 16/9;

    max-width: calc(100vw - 2rem);

    width: 100%;

    img {
      object-fit: cover;

      &[data-is-loading="true"] {
        background: linear-gradient(
          90deg,
          #2f2f2f 25%,
          #424242 50%,
          #2f2f2f 75%
        );
        background-size: 200% 100%;

        animation: ${shimmer} 1.5s infinite ease-in-out;
      }
    }

    @media (max-width: 1300px) {
      width: 61px;
      height: 34px;

      border-radius: 2px;
    }
  }

  :has(.not-released-background) {
    .missing-image-icon {
      display: none;
    }
  }

  .missing-image-icon {
    z-index: 2;
    place-self: center;

    width: 30px;
    height: 30px;

    @media (max-width: 1300px) {
      width: 20px;
      height: 20px;
    }
  }

  .image-container {
    display: grid;
    grid-template-areas: "image";

    &:has(.not-released-background) {
      filter: grayscale(100%);
    }

    .not-released-background,
    ${ImageFallback}, .missing-image-icon {
      grid-area: image;
    }

    .not-released-background {
      height: 100%;
      position: relative;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;

      flex-direction: column;
      gap: 0.5rem;

      svg {
        width: 20px;
        height: 20px;
      }
    }

    .drip-content-message-container {
      padding: 1px 3px;
      border-radius: 4px;

      white-space: initial;

      text-align: center;
      font: 600 0.5625rem/0.75rem "Inter";
      color: ${({ theme }) =>
        theme.classwork.imersive.dripContentFlagTextColor};

      background-color: ${({ theme }) =>
        theme.classwork.imersive.dripContentFlagBackgroundColor};

      display: flex;
      align-items: center;
      gap: 0.25rem;

      width: fit-content;

      @media (max-width: 1300px) {
        display: none;
      }
    }
  }

  .texts {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    margin-top: 1rem;

    .lesson-title-container {
      display: flex;
      gap: 0.5rem;
      align-items: flex-start;
      justify-content: space-between;

      text-align: start;

      svg {
        min-width: 19px;
        min-height: 19px;
      }

      :has(.drip-content-message-container) {
        display: grid;
        grid-template-columns: 1fr auto;
        gap: 0.25rem;

        .title {
          -webkit-line-clamp: 1;
        }
      }

      .title {
        font: 600 0.875rem/1.3125rem "Inter";
        color: ${({ theme }) => theme.classwork.imersive.dropdownTitle};

        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;

        max-width: 300px;

        @media (max-width: 1300px) {
          font-size: 0.75rem;
          line-height: 1.125rem;
        }
      }
    }

    .duration {
      font: 500 0.75rem/1.275rem "Inter";
      color: ${({ theme }) => (theme.mode === "dark" ? "#C8C8C9" : "#666666")};

      text-align: start;
    }
  }
`;
